<template>
    <action-modal
        :key="$route.params.clientActionId"
        :show.sync="visible"
        :client-action-id="$route.params.clientActionId"
    >
    </action-modal>
</template>

<script>
import ActionModal from '@/components/Action/Modal/ActionModal';
import ActionStatus from "@/services/Action/ActionStatus";

export default {
  name: 'ActionPage',
  components: {
    ActionModal,
  },
  data() {
    return {
      visible: true,
      previousRoute: null,
    };
  },
  computed: {
    statusFilter() {
      return this.$store.getters.actionStatusFilter;
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;
    });
  },
  watch: {
    /**
     * We're watching to see when the modal closes
     * When it does, we want to redirect it to the correct url
     * @param newVisible
     */
    visible(newVisible) {
      if (!newVisible) {

        if (this.previousRoute
            && this.previousRoute.name === 'actions') {
          this.$router.push({ name: 'actions' });
          return;
        }

        const route = {
          name: 'actionFinder',
        };
        if (this.statusFilter) {
          const routePath = ActionStatus.getRouteByStatus(this.statusFilter);

          route.name = 'actionStatus';
          route.params = {
            statusFilter: routePath,
          };
        }

        this.$router.push(route);
      }
    },
  },
  methods: {
  },
};
</script>
